/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCreateCaseNoteDraft,
    InternalApiCreateCaseNoteDraftFromJSON,
    InternalApiCreateCaseNoteDraftToJSON,
    InternalApiCreateInvestigationNote,
    InternalApiCreateInvestigationNoteFromJSON,
    InternalApiCreateInvestigationNoteToJSON,
    InternalApiInvestigationNote,
    InternalApiInvestigationNoteFromJSON,
    InternalApiInvestigationNoteToJSON,
    InternalApiNoteDraft,
    InternalApiNoteDraftFromJSON,
    InternalApiNoteDraftToJSON,
    InternalApiUpdateNoteDraft,
    InternalApiUpdateNoteDraftFromJSON,
    InternalApiUpdateNoteDraftToJSON,
} from '../models';

export interface CreateCaseNoteRequest {
    handle: string;
    internalApiCreateInvestigationNote: InternalApiCreateInvestigationNote;
}

export interface CreateCaseNoteDraftRequest {
    handle: string;
    internalApiCreateCaseNoteDraft: InternalApiCreateCaseNoteDraft;
}

export interface DeleteCaseNoteDraftRequest {
    handle: string;
    id: number;
}

export interface FindCaseNoteDraftsRequest {
    handle: string;
}

export interface FindCaseNotesRequest {
    handle: string;
}

export interface UpdateCaseNoteDraftRequest {
    handle: string;
    id: number;
    internalApiUpdateNoteDraft: InternalApiUpdateNoteDraft;
}

/**
 * 
 */
export class CaseNoteInternalApi extends runtime.BaseAPI {

    /**
     * Creates a note for a case
     */
    async createCaseNoteRaw(requestParameters: CreateCaseNoteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiInvestigationNote>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling createCaseNote.');
        }

        if (requestParameters.internalApiCreateInvestigationNote === null || requestParameters.internalApiCreateInvestigationNote === undefined) {
            throw new runtime.RequiredError('internalApiCreateInvestigationNote','Required parameter requestParameters.internalApiCreateInvestigationNote was null or undefined when calling createCaseNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/notes`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateInvestigationNoteToJSON(requestParameters.internalApiCreateInvestigationNote),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiInvestigationNoteFromJSON(jsonValue));
    }

    /**
     * Creates a note for a case
     */
    async createCaseNote(requestParameters: CreateCaseNoteRequest, initOverrides?: RequestInit): Promise<InternalApiInvestigationNote> {
        const response = await this.createCaseNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a draft note for a case
     */
    async createCaseNoteDraftRaw(requestParameters: CreateCaseNoteDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiNoteDraft>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling createCaseNoteDraft.');
        }

        if (requestParameters.internalApiCreateCaseNoteDraft === null || requestParameters.internalApiCreateCaseNoteDraft === undefined) {
            throw new runtime.RequiredError('internalApiCreateCaseNoteDraft','Required parameter requestParameters.internalApiCreateCaseNoteDraft was null or undefined when calling createCaseNoteDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/note-drafts`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateCaseNoteDraftToJSON(requestParameters.internalApiCreateCaseNoteDraft),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiNoteDraftFromJSON(jsonValue));
    }

    /**
     * Creates a draft note for a case
     */
    async createCaseNoteDraft(requestParameters: CreateCaseNoteDraftRequest, initOverrides?: RequestInit): Promise<InternalApiNoteDraft> {
        const response = await this.createCaseNoteDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a case draft note
     */
    async deleteCaseNoteDraftRaw(requestParameters: DeleteCaseNoteDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling deleteCaseNoteDraft.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteCaseNoteDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/note-drafts/{id}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a case draft note
     */
    async deleteCaseNoteDraft(requestParameters: DeleteCaseNoteDraftRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteCaseNoteDraftRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches user\'s drafts for a case
     */
    async findCaseNoteDraftsRaw(requestParameters: FindCaseNoteDraftsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiNoteDraft>>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling findCaseNoteDrafts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/note-drafts`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiNoteDraftFromJSON));
    }

    /**
     * Fetches user\'s drafts for a case
     */
    async findCaseNoteDrafts(requestParameters: FindCaseNoteDraftsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiNoteDraft>> {
        const response = await this.findCaseNoteDraftsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all notes for a case
     */
    async findCaseNotesRaw(requestParameters: FindCaseNotesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiInvestigationNote>>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling findCaseNotes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/notes`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiInvestigationNoteFromJSON));
    }

    /**
     * Fetches all notes for a case
     */
    async findCaseNotes(requestParameters: FindCaseNotesRequest, initOverrides?: RequestInit): Promise<Array<InternalApiInvestigationNote>> {
        const response = await this.findCaseNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a case draft note
     */
    async updateCaseNoteDraftRaw(requestParameters: UpdateCaseNoteDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiNoteDraft>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling updateCaseNoteDraft.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateCaseNoteDraft.');
        }

        if (requestParameters.internalApiUpdateNoteDraft === null || requestParameters.internalApiUpdateNoteDraft === undefined) {
            throw new runtime.RequiredError('internalApiUpdateNoteDraft','Required parameter requestParameters.internalApiUpdateNoteDraft was null or undefined when calling updateCaseNoteDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/note-drafts/{id}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiUpdateNoteDraftToJSON(requestParameters.internalApiUpdateNoteDraft),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiNoteDraftFromJSON(jsonValue));
    }

    /**
     * Updates a case draft note
     */
    async updateCaseNoteDraft(requestParameters: UpdateCaseNoteDraftRequest, initOverrides?: RequestInit): Promise<InternalApiNoteDraft> {
        const response = await this.updateCaseNoteDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
